import { type QueryClient, useQueryClient } from "react-query";

import { useSessionTurns } from "src/components/llm/hooks/use-session-turns";
import {
  useAmpLibraryCountsQuery,
  useAmpLibraryFilesQuery,
  useAmpLibraryFoldersQuery,
} from "src/graphql";

/** Reads again what an agent may have just saved: open files' versions, canvases, and the Library's lists. Polling catches the rest later. */
export function refreshAmpFiles(queryClient: QueryClient) {
  void queryClient.invalidateQueries("AmpFileStamp");
  void queryClient.invalidateQueries("AmpLibraryCanvas");
  void queryClient.invalidateQueries(useAmpLibraryFilesQuery.getKey());
  void queryClient.invalidateQueries(useAmpLibraryCountsQuery.getKey());
  void queryClient.invalidateQueries(useAmpLibraryFoldersQuery.getKey());
}

/** Refreshes the AMP files each time a turn of the AMP chat ends. */
export function useRefreshAmpFilesAfterTurns(sessionId: string | null) {
  const queryClient = useQueryClient();
  useSessionTurns(sessionId, { onEnd: () => refreshAmpFiles(queryClient) });
}
